import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Section } from '@wix/da-shared-react/pkg/a11y/headings/tagWrappers';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import Heading from '@wix/da-shared-react/pkg/a11y/headings/Heading';
import PageContainer from '../PageContainer';
import BrowsePageHeading from '../../../BrowsePageHeading';
import DefaultPageContent from '../DefaultPageContent';
import s from './BasePageLayout.scss';

export interface Props {
  feedType?: string;
  title?: React.ReactNode;
  tagLine?: React.ReactNode;
  headerNavigation?: React.ReactNode;
  headerRightSideContent?: React.ReactNode;
  withNavigation?: boolean;
  contentClassName?: string;
  children?: React.ReactNode;
}

const BasePageLayout: React.FC<Props> = ({
  title,
  tagLine,
  headerNavigation,
  headerRightSideContent,
  feedType,
  children,
  withNavigation,
  contentClassName,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {/*
        We're putting this h1 out here because we need it to be before any sections in the page.

        This makes sure that this heading is associated with the body.
      */}
      <BrowsePageHeading />
      <PageContainer
        title={title}
        tagLine={tagLine}
        headerNavigation={headerNavigation}
        headerRightSideContent={headerRightSideContent}
        withNavigation={withNavigation}
      >
        <Section>
          <VisuallyHidden>
            <Heading>{t('facetPage.contentHeading')}</Heading>
          </VisuallyHidden>
          <div
            className={classnames(
              s['root'],
              s[`feed-${feedType}`],
              contentClassName
            )}
          >
            {children ? children : <DefaultPageContent />}
          </div>
        </Section>
      </PageContainer>
    </>
  );
};
BasePageLayout.displayName = 'BasePageLayout';

export default BasePageLayout;
